import React from 'react';
import { partners } from '../mockData';

const Partnerships = () => {
  return (
    <div className="page-container">
      {/* Partnerships Hero */}
      <section className="partnerships-hero-section">
        <div className="container">
          <h1 className="heading-1">OUR PARTNERS & CLIENTS</h1>
          <p className="body-large max-w-4xl">
            Trusted by leading organizations across Government & Public Sector, Consumer Markets, 
            Healthcare, Tourism, Finance, and Knowledge-Intensive Industries worldwide.
          </p>
        </div>
      </section>

      {/* Partners Grid */}
      <section className="section-padding">
        <div className="container">
          <h2 className="heading-4 text-center mb-96">ORGANIZATIONS WE'VE WORKED WITH</h2>
          <div className="partners-grid">
            {partners.map((partner, index) => (
              <div key={index} className="partner-card">
                <div className="partner-logo-container">
                  <img src={partner.logo} alt={partner.name} className="partner-logo-img" />
                  <span className="partner-name">{partner.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnership Approach */}
      <section className="section-padding bg-card">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">OUR PARTNERSHIP APPROACH</h2>
          <div className="partnership-approach-grid">
            <div className="partnership-approach-item">
              <h3 className="heading-5">Long-Term Relationships</h3>
              <p className="body-small">
                We believe in building lasting partnerships, not just project-based engagements. 
                Our goal is to become a trusted extension of your team.
              </p>
            </div>
            <div className="partnership-approach-item">
              <h3 className="heading-5">Industry Expertise</h3>
              <p className="body-small">
                Deep understanding of sector-specific challenges and opportunities across 
                government, healthcare, tourism, finance, and technology industries.
              </p>
            </div>
            <div className="partnership-approach-item">
              <h3 className="heading-5">Global Network</h3>
              <p className="body-small">
                Strategic partnerships with international media platforms and agencies enable 
                us to deliver global solutions with local expertise.
              </p>
            </div>
            <div className="partnership-approach-item">
              <h3 className="heading-5">Measurable Impact</h3>
              <p className="body-small">
                Every partnership is evaluated on tangible outcomes - from brand visibility 
                and audience engagement to business growth and market penetration.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sectors We Serve */}
      <section className="section-padding">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">SECTORS WE SERVE</h2>
          <div className="sectors-grid">
            <div className="sector-item">
              <h3 className="heading-5">Government & Public Sector</h3>
              <p className="body-small">
                Strategic communication and digital transformation for government agencies, 
                public institutions, and tourism boards.
              </p>
            </div>
            <div className="sector-item">
              <h3 className="heading-5">Healthcare & Life Sciences</h3>
              <p className="body-small">
                Specialized communication for hospitals, pharmaceutical companies, 
                research institutions, and healthcare organizations.
              </p>
            </div>
            <div className="sector-item">
              <h3 className="heading-5">Financial Services</h3>
              <p className="body-small">
                Brand building and communication strategies for banks, financial institutions, 
                and fintech companies across markets.
              </p>
            </div>
            <div className="sector-item">
              <h3 className="heading-5">Consumer & Retail</h3>
              <p className="body-small">
                B2C, D2C, and hybrid commerce solutions for brands targeting consumer 
                audiences with integrated marketing approaches.
              </p>
            </div>
            <div className="sector-item">
              <h3 className="heading-5">Technology & Innovation</h3>
              <p className="body-small">
                Communication strategies for tech companies, startups, and innovation-driven 
                organizations in rapidly evolving markets.
              </p>
            </div>
            <div className="sector-item">
              <h3 className="heading-5">Aviation & Transportation</h3>
              <p className="body-small">
                Brand positioning and communication services for airlines, transportation 
                companies, and mobility solutions providers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Placeholder */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">CLIENT TESTIMONIALS</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="testimonial-quote">
                "Vaikuntha Media transformed our communication strategy with their data-driven 
                approach and deep understanding of our industry. Exceptional results."
              </p>
              <p className="testimonial-author">— Healthcare Client</p>
            </div>
            <div className="testimonial-card">
              <p className="testimonial-quote">
                "Their ability to bridge traditional media and digital ecosystems helped us 
                reach new audiences while maintaining brand integrity."
              </p>
              <p className="testimonial-author">— Tourism Board</p>
            </div>
            <div className="testimonial-card">
              <p className="testimonial-quote">
                "A truly client-centric agency that delivers on promises. Their strategic 
                thinking and execution capabilities are world-class."
              </p>
              <p className="testimonial-author">— Financial Services</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-2">BECOME A PARTNER</h2>
            <p className="body-large">
              Let's discuss how we can help your organization achieve its communication 
              and business objectives.
            </p>
            <a href="/contact" className="btn-primary btn-large">
              Start the Conversation
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partnerships;
